module.exports = __webpack_public_path__ + "static/media/banner2.39094917.jpg";